import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getNews } from 'api/Blog';

export const fetchNews = createAsyncThunk(
    'news',
    async () => {
        const response = await getNews();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            const { news } = getState();
            if (news.data) return false;
        },
    },
);

const newsSlice = createSlice({
    name: 'news',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchNews.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default newsSlice.reducer;
